export const MONITOR_KEY_QUERY_PARAM = 'pc'

/** CPR-shared AES secret for Talent Studio `pc` decrypt. */
export const MONITOR_KEY_SECRET = 'ts-fts-task-encryption-key'

/**
 * Talent Studio `secure` profile = screen only (no camera / microphone).
 * `strict` (and other profiles) = screen + camera + mic.
 */
export const isSecureProctoringProfile = (profile?: string | null) =>
    String(profile || '')
        .trim()
        .toLowerCase() === 'secure'
